import instance from "./BasebDotdigitalApi";

export function validateDotdigitalCredentials(data) {
  return instance.request({
    url: `validate-credentials/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function saveDotdigitalConfigs(data) {
  return instance.request({
    url: `save-configs/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function getDotdigitalLists(organisationId) {
  return instance.request({
    url: `lists/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function saveDotdigitalMappings(data) {
  return instance.request({
    url: `save-mappings/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function getDotdigitalStatus(organisationId) {
  return instance.request({
    url: `status/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getDotdigitalMappings(organisationId) {
  return instance.request({
    url: `mappings/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function deactivateDotdigital(data) {
  return instance.request({
    url: `deactivate/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}
